module.exports = __webpack_public_path__ + "static/illustration-dc6bff08aa5d690d8d42e73ccfef728e.png";